window.mrk = window.mrk || {};
var rtl = false;
if(document.dir == 'rtl')
  rtl = true;
$(document).ready(function() {
    $(document).on('mrk:addToCart', function() {
        $('[aria-busy="true"]').attr('aria-busy', false);
    });
    
    $("body").click(function(event) {
        if (!$(event.target).closest('.color-selection__selection-container').length) {
            $('.color-selection__grid-item.active').removeClass('active');
            $('.color-selection__selection-container').hide();
            $('body').removeClass('color-choose-active');
        }
    });
    if($('.mrk-slider-main .nav-item').length > 5){
    $('.mrk-slider-main').each(function(_, elem) {
        $(elem).slick({
            dots: true,
            infinite: true,
            loop: true,
            autoplay: false,
            arrows: true,
            speed: 700,
            rtl,
            slidesToShow: 6,
            slidesToScroll: 1,
            lazyLoad: 'progressive',
            responsive: [{
                    breakpoint: 1980,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 576,
                    settings: "unslick"
                }
            ]
        });
    });
    }
    
    $('.nav-link').click(function() {
        var $this = $(this);
    
        $('.nav-link').removeClass('active');
        $this.addClass('active');
        $('.tab-pane').removeClass('active show');
        moveTo($('.gift__description'));
        $($this.data('target')).addClass('active show');
    
        if ($this.hasClass('initSliderVariants')) {
            ramadanGiftSlider();
        }
    });
    
    $(".step1button").on('click', function() {
        var $this = $(this);
        var pcs = Number($("#pcs").val());
        var pcsAuto = Number($("#atomizer-count").val());
        $("#step2button").addClass('disabled');
        $('#variant_id').val($this.attr('data-variant'));
        if ($this.attr('skip-step-2') == 'false') {
            $('.gobackStep2').attr('skip-step-2', false);
            document.querySelector('gift-box-drawer').show();
            $("#pcs").val($this.attr("data-pieces"));
            $("#atomizer-count").val($this.attr("data-atomizer") || 0);
            $('#slidergiftcontainer').html('');
            var url = $(this).attr('product_url');
            var selector = $('#slidergiftcontainer');
            $('.step-2').removeClass('step-hide');
            $('.step-3').addClass('step-hide');
            moveTo($('.step-2'));
            getData(url,selector,productssliderreinit);
            $('.gobackStep2').show();
        } else {
            $('.gobackStep2').hide();
            $('.gobackStep2').attr('skip-step-2',true);
            $('#slidergiftcontainer').html('');
            $('.step-2').addClass('step-hide');
            $('.step-3').removeClass('step-hide');
            moveTo($('.step-3'));
            document.querySelector('gift-box-drawer').show();
            getData($this.attr('collection_url'), $('.mrk-selected-data'), renderBrands);
        }
    });

    const handleBrandLoad = (event) => {
        const selector = event.detail.mrk;
        $(selector).find('a').each(function() {
            const tagClass = $(this).attr('data-tag');
            $(this).closest('.color-selection__selection-container').find('.model-select')
                   .append(`<div class="mrk-flex-sub ${tagClass}"></div>`);
        });
    };

    const handleBrandProducts = (event) => {
        const selector = event.detail.mrk;
        const timestamp = Math.floor(Date.now() / 1000);
        const updatedContent = $(selector).html().replace(/mrkdynamictime/g, timestamp);
        $(selector).html(updatedContent);
    };
    function bindEvents(){
        $('.gift_slickslider .quantity a').unbind('click');
        $('.gift_slickslider .quantity a').click(function(){
            var input = $(this).parents('.quantity').find('input');
            var bottle = $(this).parents('.quantity__selection__in');
            var pcs = Number($("#pcs").val());
            var pcsAuto = Number($("#atomizer-count").val());
            var count = input.val();
            if($(this).hasClass('minusgift') && input.val() != 0){
                count--;
                input.val(count);
                // console.log(input,count);
                $('.notificationgift_slider1').html('You have selected ' + totalNumberOfGifts() + ' design(s) out of ' + pcs);
                //$(this).addClass('disabled')
                if(input.val() == 0)
                $(bottle).removeClass('bottleActive');
                if (pcs + pcsAuto != totalNumberOfGifts() + totalNumberOfAtomizer()) {
                    $("#step2button").addClass('disabled')
                }
            }
            if($(this).hasClass('plusgift')){
                if (pcs > totalNumberOfGifts()) {
                    count++;
                    $(bottle).addClass('bottleActive');
                    input.val(count);
                    // console.log(input,count);
                    $('.notificationgift_slider1').html('You have selected ' + totalNumberOfGifts() + ' design(s) out of ' + pcs);
                    //$(this).addClass('disabled')
                    
                    if (pcs + pcsAuto == totalNumberOfGifts() + totalNumberOfAtomizer()) {
                        $("#step2button").removeClass('disabled')
                    }else{
                      $("#step2button").addClass('disabled')
                    }
                } else {
                    $('.notificationgift_slider1').html('You have reached ' + totalNumberOfGifts() + ' design(s)');
                }
            }
            updateCounter(pcs + pcsAuto,totalNumberOfGifts() + totalNumberOfAtomizer())
        });
        $('.mrk-automizer .quantity a').unbind('click');
        $('.mrk-automizer .quantity a').click(function(){
            var input = $(this).parents('.quantity').find('input');
            var bottle = $(this).parents('.quantity__selection__in');
            var pcs = Number($("#pcs").val());
            var pcsAuto = Number($("#atomizer-count").val());
            var count = input.val();
            if($(this).hasClass('minusgift') && input.val() != 0){
                count--;
                input.val(count);
                // console.log(input,count);
                $('.notificationgift_slider2').html('You have selected ' + totalNumberOfAtomizer() + ' design(s) out of ' + pcsAuto);
                //$(this).addClass('disabled')
                if(input.val() == 0)
                $(bottle).removeClass('bottleActive');
                if (pcs + pcsAuto != totalNumberOfGifts() + totalNumberOfAtomizer()) {
                    $("#step2button").addClass('disabled')
                }
            }
            if($(this).hasClass('plusgift')){
                if (pcsAuto > totalNumberOfAtomizer()) {
                    count++;
                    $(bottle).addClass('bottleActive');
                    input.val(count);
                    // console.log(input,count);
                    $('.notificationgift_slider2').html('You have selected ' + totalNumberOfAtomizer() + ' design(s) out of ' + pcsAuto);
                    //$(this).addClass('disabled')
                    
                    if (pcs + pcsAuto == totalNumberOfGifts() + totalNumberOfAtomizer()) {
                        $("#step2button").removeClass('disabled')
                    }
                } else {
                    $('.notificationgift_slider2').html('You have reached ' + totalNumberOfAtomizer() + ' design(s)');
                }
            }
            updateCounter(pcs + pcsAuto,totalNumberOfGifts() + totalNumberOfAtomizer())

        });
        $('.color-selection__image--top').unbind('click');
        $('.color-selection__image--top').click(function(e) {
            e.preventDefault();
            e.stopPropagation();
            var count = $(this).closest('.color-selection__grid-item').data('count');
            $('.color-selection__selection-container').css('display', 'none');
            if ($(this).closest('.color-selection__grid-item').hasClass('active')) {
                $('.color-selection__grid-item.active').removeClass('active');
                $('.color-selection__selection-container').hide();
                $('body').removeClass('color-choose-active');
            } else {
                $('.color-selection__grid-item.active').removeClass('active');
                $(this).closest('.color-selection__grid-item').addClass('active');
                $(`.color-selection__selection-container[data-count=${count}]`).css('display', 'flex');
                if(!$(`.color-selection__selection-container[data-count=${count}]`).find('.nav-active').length){
                    $(`.color-selection__selection-container[data-count=${count}]`).find('.link-bar__linklist>li:first-child>a').trigger('click');
                }
                $('body').addClass('color-choose-active');
            }
        });
        initSearch();
        initSelect();
        $('.final-product-item').unbind('change');
        $('.final-product-item').unbind('click');
        $('.final-product-item').on('change',function(){
            var _this = $(this);
            $(this).parents('.model-select').find('.final-product-item:checked').each(function(){
                if($(_this).attr('id') != $(this).attr('id'))
                $(this).prop('checked',false)
            });
            var image = $(this).attr('image');
            var title = $(this).val();
            $(this).parents('.color-selection__grid-item').find('.color-selection__image--top').css('background-image', `url(${image})`).addClass('image-loaded');
            $(this).parents('.color-selection__grid-item').find('.mrk-seleted-name').html(title);
            $('.color-selection__grid-item.active').removeClass('active');
            $('.color-selection__selection-container').hide();
            $('body').removeClass('color-choose-active');
        })
        $('.link-bar__wrapper a[data-tag]').unbind('click');
        $('.link-bar__wrapper a[data-tag]').on('click',function(e){
            e.preventDefault();
            e.stopPropagation();
            $(this).parents('.color-selection__selection-container').find('.nav-active').removeClass('nav-active');
            $(this).addClass('nav-active');
            var tag = $(this).data('tag');
            $(this).parents('.color-selection__selection-container').find('.mrk-flex-sub').css('display', 'none');
            $(this).parents('.color-selection__selection-container').find(`.${tag}`).css('display', 'flex');
            var url = $(this).attr('data-href');
            var selector = $(this).parents('.color-selection__selection-container').find(`.model-select .${tag}`);
            if($(selector).html()== '')
            getData(url,selector);
        });
        enableFinalAddToCart();
        renderMix();
    }
    
    function getData(url,selector,callback){
        var callback = callback || function() { };
        $.ajax({
            type: "GET",
            url,
            dataType: "html",
            cache: true,
            beforeSend: function(){
                $(selector).html(`<div class="mrk-loader"><div class="lds-dual-ring"></div></div>`).addClass('mrk-loading');
            },
            success: function (response) {
                selector.html(response).removeClass('mrk-loading');
                callback();
                if(url != undefined  && url.includes('view=brandProducts')){
                      document.dispatchEvent(new CustomEvent("brandProducts", {detail: {mrk:selector}}));
                }
                bindEvents();
                if(url != undefined  && url.includes('view=brands')){
                    document.dispatchEvent(new CustomEvent("brandLoaded", {detail: {mrk:selector}}));
                }
                
            }
        });
    }
    function updateCounter(total,current){
        $('.mrk-progress-counter').each(function() {
            const percent = (current * 100) / total;
            $(this).css({'--value': percent})
            $(this).find('.mrk-inner-progress').text(`${current}/${total}`);
        });
    }
    $('#stepAddCartbutton,.mrk-directadd-to-cart').click(function(){
        var products_names = '';
        $(this).attr('aria-busy', true);
        $('.mrk-gift-attributes').html('');
        if(!$(this).hasClass('mrk-directadd-to-cart')){
            $('.mrk-final-product-list .selected-value[value]').each(function(index,item) {
                var bottle = $(this).parents('.model-select').attr('bottlename');
                if(bottle != undefined)
                var title = $(this).attr('value') + ' - ' + bottle;
                else
                var title = $(this).attr('value');
                var item = `<input type="hidden" name="properties[${index+1}]" value="${title}">`;
                products_names = products_names + item;
            });
            $('.mrk-gift-attributes').html('').html(products_names);
        }else{
          $('#variant_id').val('');
        }
        var alter_id = $(this).attr('data-variant');
        console.log(alter_id,$('#variant_id').val());
        if($('#variant_id').val() == ''){
          var id = alter_id;
        }else{
          var id = $('#variant_id').val();
        }
        $('#mrk-gift-form-id [name="id"]').val(id);
        $('#mrk-gift-form-id [type="submit"]').click();
    });
    $(document).on('brandLoaded', handleBrandLoad).on('brandProducts', handleBrandProducts);
    $('.gobackStep2').on('click', gotostep2);
    $('.gobackStep1').on('click', gotostep1);
    $('#step2button').on('click', Step3Data);

    bindEvents();
    function totalNumberOfGifts() {
        return $('.gift_slickslider.simple input').toArray().reduce((acc, input) => acc + Number($(input).val()), 0);
    }
    
    function totalNumberOfAtomizer() {
        var count = 0;
        $('.mrk-automizer input').each(function(){
            count = count + Number($(this).val());
        });
        return count
    }
    
    function slideAnimation($element, outClass, callback) {
        $element.addClass(outClass).animate(outClass, function () {
            $element.addClass('step-hide').removeClass(outClass);
            callback();
        });
    }
    
    function Step3Data() {
        slideAnimation($('.step-2'), 'slideOutLeft', () => {
            $('.step-3').removeClass('step-hide');
            moveTo($('.step-3'));
            renderthirdStepData();
        });
    }
    
    function gotostep1() {
        slideAnimation($('.step-2'), 'slideOutRight', () => moveTo($('.step-1')));
    }
    
    function gotostep2() {
        const skipStep2 = $(this).attr('skip-step-2') === 'false';
    
        slideAnimation($('.step-3'), 'slideOutRight', () => {
            if (skipStep2) {
                $('.step-2').removeClass('step-hide').addClass('slideInLeft');
                moveTo($('.step-2'));
            } else {
                moveTo($('.step-3'));
            }
        });
    }
    
    function renderthirdStepData(){
        var final_output = '';
        $('.bottleActive').each(function(){
            var loop = Number($(this).find('input').val());
            var image = $(this).find('img').attr('src');
            var bottleName = $(this).find('img').attr('bottleName');
            var url = $(this).find('input').attr('collection');
            for(i=1;i <= loop;i++){
                var item = `<div class="colcls">
                    <div class="secbottle">
                    <img src="${image}" class="img-responsive">
                    </div>
                    <div class="secselect">
                        <div id="bottlemodel1-${i}" class="brands-select" url="${url}" style="width:100%"></div>
                        <div id="bottlemodel2-${i}" class="model-select"  bottleName="${bottleName}" style="width:100%"><div class="mrk-selected-option">
                        <span class="selected-value">Select Fragrance</span>
                    </div></div>
                    </div>
                </div>
                `;
                final_output = final_output + item;
            }
        });
        $('.mrk-selected-data').html(final_output);
        renderBrands();
    }
    
    function renderBrands(){
        $('.mrk-selected-data').find('.brands-select').each(function(){
            var url = $(this).attr('url');
            var selector = $(this);
            getData(url,selector);
        })
    }
    function renderBrandProducts(li){
        var url = $(li).attr('value');
        var selector = $(li).parents('.secselect').find('.model-select');
        // console.log(selector);
        getData(url,selector);
    }
    
    function renderMix() {
        $('.mrk-mix-gift-box').off('change').on('change', function() {
            const image = $(this).find('option:checked').attr('image');
            $(this).closest('.colcls').find('img').attr('src', image);
            enableFinalAddToCart();
        });
    }
    
    function enableFinalAddToCart() {
        const totalLength = $('.mrk-selected-data .colcls').length;
        const checkedLength = $('.mrk-final-product-list .selected-value[value]').length;
        const isDisabled = checkedLength !== totalLength;
        updateCounter(totalLength,checkedLength);
        $('#stepAddCartbutton').toggleClass('disabled', isDisabled);
    }
    
    function productssliderreinit() {
        var title = $('.nav-link.active .gift__nav__inner h4').html();
        $('.mrk-selected-title').html(title);
        const sliderSettings = {
            dots: false,
            infinite: true,
            loop: true,
            autoplay: false,
            arrows: true,
            rtl,
            speed: 700,
            slidesToShow: 3,
            slidesToScroll: 3,
            lazyLoad: 'progressive',
            responsive: [
                { breakpoint: 1980, settings: { slidesToShow: 3, slidesToScroll: 3 } },
                { breakpoint: 1400, settings: { slidesToShow: 3, slidesToScroll: 3 } },
                { breakpoint: 992, settings: { slidesToShow: 3, slidesToScroll: 3 } },
                { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 2 } },
                { breakpoint: 576, settings: { slidesToShow: 2, slidesToScroll: 2 } }
            ]
        };
    
        $('.gift_slickslider').each(function() {
            $(this).slick(sliderSettings);
        }).slick('unslick').slick('reinit');
        $('.gift_slickslider .quantity a:eq(0)').trigger('click');
        setTimeout(function(){$('.gift_slickslider .quantity a:eq(0)').trigger('click');},100)
    }
    
    function ramadanGiftSlider() {
        const sliderSettings = {
            dots: false,
            infinite: true,
            centerPadding: '30px',
            loop: true,
            autoplay: false,
            arrows: true,
            rtl,
            centerMode: true,
            speed: 200,
            slidesToShow: 1,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerPadding: '15px',
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        centerPadding: '10px',
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        centerPadding: '5px',
                        slidesToScroll: 1
                    }
                }
            ]
        };
    
        function handleAfterChange(event, sliderClass) {
            const variant = $(this).find('.slick-center').attr('data-variant');
            const color_img = $(this).find('.slick-center').attr('data-img');
    
            $(this).parents('.tab-pane').find('.step1button').attr('data-variant', variant);
            $("#variant_id").val(variant);
            $(".step1button").attr('data-img', color_img);
            $(`.bottleslider.${sliderClass}`).removeClass('active');
            $(`.slick-center.${sliderClass}`).addClass('active');
        }
    
        $('.colorslider').slick(sliderSettings).on('afterChange', function(event, slick) {
            handleAfterChange.call(this, event, 'bottleslidersmall');
        });
    
        $('.colorsliderlarge').slick({...sliderSettings, centerPadding: '40px'}).on('afterChange', function(event, slick) {
            handleAfterChange.call(this, event, 'bottlesliderlarge');
        });
        $('.gift_slickslider .quantity a:eq(0)').trigger('click');
    }
    
    function moveTo(e) {
        var title = $('.nav-link.active .gift__nav__inner h4').html();
        $('.mrk-selected-title').html(title);
        console.log($(e).offset().top,e);
        if(!e.hasClass('step-3')){
            $('html, body').animate({
                scrollTop: $(e).offset().top - 200
            }, 500);
        }
    }
    
    function initSearch() {
        // Handle input event with delegation
        $('.mrk-search-bar input').unbind('input');
        $('.mrk-search-bar input').on('input', function() {
            const searchValue = $(this).val().toLowerCase();
            const linkList = $(this).parents('.mrk-custom-dropdown').find('.option-list li');
            // console.log(searchValue.length, $(this));

            if (searchValue.length === 0) {
                linkList.show();
                return;
            }
            linkList.each(function() {
                const linkText = $(this).text().toLowerCase();
                linkText.includes(searchValue) ? $(this).show() : $(this).hide();
            });
        });
    }
    function initSelect(){
        $('.mrk-selected-option').unbind('click');
        $('.mrk-custom-dropdown li').unbind('click');
        $('.mrk-selected-option').click(function (e) { 
            e.preventDefault();
            $(this).parents('.mrk-custom-dropdown').find('.dropdown-wrapper').slideToggle('fast');
        });
        $('.mrk-custom-dropdown li').click(function (e) {
            $(this).parents('.dropdown-wrapper').slideUp('fast');
            var value = $(this).attr('value');
            var text = $(this).text();
            var image = $(this).attr('image');
            $(this).parents('.mrk-custom-dropdown').find('.selected-value').text(text).attr('value', value);
            if($(this).parents('.mrk-custom-dropdown').hasClass('selectbottlebrand')){
                renderBrandProducts($(this))
            }
            if($(this).parents('.mrk-custom-dropdown').hasClass('mixology')){
                $(this).parents('.mrk-custom-dropdown').find('.selected-value').attr('image', image);
                $(this).parents('.colcls').find('.img-responsive').attr('src', image);
                console.log(image);
            }
            enableFinalAddToCart()
        });
        $(document).click(function(e) {
            if (!$(e.target).closest('.mrk-custom-dropdown').length) {
                $('.dropdown-wrapper').slideUp('fast');
            }
        });
    }
    function getURLParameter(name) {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
    }

    // Get the value of the 'gift' parameter from the URL
    var giftValue = getURLParameter('gift');

    // Check if the 'gift' parameter exists and has a value
    if (giftValue) {
        // Find the element with the matching 'gift' attribute and click it
        $('[gift="' + giftValue + '"] a').click();
    }
}); 
